/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tab-buttons[_ngcontent-%COMP%]{margin:0 20px 10px!important;-webkit-box-pack:center!important;justify-content:center!important}.modal-title[_ngcontent-%COMP%]{font-weight:700}.modal-body[_ngcontent-%COMP%]{text-align:center;height:271px;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:justify;justify-content:space-between;font-size:16px}.subtitle[_ngcontent-%COMP%]{font-size:22px;font-weight:700}"];
export { styles as styles };
